/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
import { Tree } from 'antd';
import { DownOutlined } from '@ant-design/icons';

const { TreeNode } = Tree;

class GroupTree extends React.Component {
  constructor(props) {
    super(props);
    this.config = this.props.context;
    this.state = {};
  }
  renderTreeNodes = data => {
    return data.map(item => {
      if (item !== null) {
        if (item.hasOwnProperty('childrenGroups')) {
          return (
            <TreeNode title={item.name} key={item.resourcePath} dataRef={item}>
              {this.renderTreeNodes(item.childrenGroups)}
            </TreeNode>
          );
        }
        return <TreeNode title={item.name} key={item.resourcePath} {...item} />;
      }

      return null;
    });
  };

  render() {
    const {
      data,
      onExpand,
      onCheck,
      expandedKeys,
      autoExpandParent,
      checkedKeys,
      treeNodeStyle,
      treeNodeSelectedStyle,
    } = this.props;
    return (
      <Tree
        showLine
        switcherIcon={<DownOutlined />}
        onExpand={onExpand}
        onCheck={onCheck}
        expandedKeys={expandedKeys}
        autoExpandParent={autoExpandParent}
        onSelect={onCheck}
        checkedKeys={checkedKeys}
        treeNodeStyle={treeNodeStyle}
        treeNodeSelectedStyle={treeNodeSelectedStyle}
        blockNode
      >
        {this.renderTreeNodes(data)}
      </Tree>
    );
  }
}

export default GroupTree;
